import { render } from "./PrimaryButton.vue?vue&type=template&id=174f6570&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=174f6570&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-174f6570"

export default script